import React from 'react'
import {
  CustomComponent as CustomComponentType,
  CustomComponentTypes,
} from '../../types/landingPageV2'
import { BGVariants } from '../../types/heroTextSection'
import useBrand from '../../hooks/useBrand'
import { withHideOn } from '../../hocs/withHideOn'
import NotFindingWhatYouWantTry from '../NotFindingWhatYouWantTry/NotFindingWhatYouWantTry'
import FiveStarColumn from '../TrustPilot/FiveStarColumn'
import NavigationGroupPhone from '../NavigationGroup/NavigationGroupPhone'
import PurchaseFooter from '@talentinc/zipjob.com/src/components/PurchaseFooter'
import PackagesContainer from '../Packages/PackagesContainer'
import ContactForm from '../Forms/ContactForm'
import ContactFormInSection from '../Forms/ContactFormInSection'
import AffirmPriceComponent from '../Affirm/AffirmPriceComponent'
import Press from '..//Press/Press'
import Match from '../Match/Match'
import DoNotSell from '../Forms/DoNotSell'
import PartnershipForm from '../Forms/PartnerForm'
import NewsletterForm from '../Forms/NewsletterForm'
import LearnMore from '../LearnMore/LearnMore'

export type CustomComponentProps = {
  item: CustomComponentType
  color?: BGVariants
  containerClass?: string
  phoneClass?: string
  sectionClass?: string
  variant?: string
}

const CustomComponent: React.FC<CustomComponentProps> = ({
  item,
  color,
  containerClass,
  phoneClass,
  sectionClass,
  variant,
}) => {
  const brand = useBrand()
  let component: React.ReactNode = null
  switch (item.name) {
    // @TODO: This isn't used, clean it up
    // https://app.contentful.com/spaces/7thvzrs93dvf/entries/3UOTy2PKXcVrwNSdhKHDNr
    case CustomComponentTypes.InPostServices:
      component = (
        <PurchaseFooter sectionClass={sectionClass} variant="inPost" />
      )
      break
    case CustomComponentTypes.PurchaseFooter:
      component = <PurchaseFooter sectionClass={sectionClass} />
      break
    case CustomComponentTypes.TrustPilotColumn:
      component = <FiveStarColumn containerClass={containerClass} />
      break
    case CustomComponentTypes.PhoneNumber:
      component = (
        <>
          {brand.phoneNumber && (
            <NavigationGroupPhone
              phoneClass={phoneClass}
              phoneProps={{
                contentful_id: item.contentful_id,
                text: brand.phoneNumber,
                url: `tel:${brand.phoneNumber}`,
                // @ts-ignore
                __typename: item.__typename,
              }}
              variant={variant}
            />
          )}
        </>
      )
      break
    case CustomComponentTypes.PackageFastTrack:
    case CustomComponentTypes.PackageLaunch:
    case CustomComponentTypes.PackagePremium:
    case CustomComponentTypes.PackageReview:
    case CustomComponentTypes.PackageExecutive:
    case CustomComponentTypes.PackageExecutiveExpanded:
      component = (
        <PackagesContainer cardColor={color} singlePackage={item.name} />
      )
      break
    case CustomComponentTypes.PricingPackages:
      component = <PackagesContainer />
      break
    case CustomComponentTypes.PricingPackagesWithReview:
      component = <PackagesContainer review={true} />
      break
    case CustomComponentTypes.ContactForm:
      component = <ContactForm />
      break
    case CustomComponentTypes.ContactFormInSection:
      component = <ContactFormInSection />
      break
    case CustomComponentTypes.AffirmPrice:
      component = <AffirmPriceComponent />
      break
    case CustomComponentTypes.Press:
      component = <Press sectionClass={sectionClass} />
      break
    case CustomComponentTypes.Match:
      component = <Match sectionClass={sectionClass} />
      break
    case CustomComponentTypes.DoNotSellForm:
      component = <DoNotSell sectionClass={sectionClass} />
      break
    case CustomComponentTypes.PartnershipsForm:
      component = <PartnershipForm />
      break
    case CustomComponentTypes.NewsletterForm:
      component = <NewsletterForm />
      break
    case CustomComponentTypes.NotFindingWhatYouWantTry:
      component = <NotFindingWhatYouWantTry />
      break
    case CustomComponentTypes.LearnMore:
      component = <LearnMore />
      break
    default:
      component = null
      break
  }
  return component
}

export default withHideOn(CustomComponent)
